<template>
  <section class="page dashboard">
      <div class="wrap">
            <div class="dashboard-update">
                <p>Обновлено: {{ updated }}</p>
            </div>
          <div class="dashboard-body" v-if="dashboard">
            <div class="dashboard-counters">
                <div class="dashboard-counter" v-if="dashboard.counters">
                    <p>Зарегистрировано</p>
                    <h3>{{dashboard.counters.register || '-'}} | {{dashboard.counters.register_today}}</h3>
                </div>
                <div class="dashboard-counter">
                    <p>Актив / Не актив</p>
                    <h3>{{dashboard.counters.activated || '-'}} | {{dashboard.counters.non_activated || '-'}}</h3>
                </div>
                <div class="dashboard-counter">
                    <p>Посещения</p>
                    <h3> {{dashboard.counters.guests_today}}</h3>
                </div>
                <div class="dashboard-counter">
                    <p>Гости | % регнувшихся</p>
                    <h3>{{getGuests() || '-'}} | {{getCTR}}</h3>
                </div>
                <!-- <div class="button" @click="sendActivations()">
                    <p>Отправить письма с активацией</p>
                </div> -->
            </div>
            <div class="dashboard-charts">
                <LineChart :chart_data="getChartData" />
            </div>
            <div class="dashboard-table">
                <div class="dashboard-headers">
                    <div class="dashboard-switcher">
                        <p :class="{active: true}">Devices</p>
                    </div>
                </div>
                <table v-if="dashboard.devices">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Token</th>
                            <th>Platform</th>
                            <th>User_id</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="device in dashboard.devices" :key="device.id">
                            <td>{{ device.id }}</td>
                            <td>{{ device.token }}</td>
                            <td>{{ device.platform }}</td>
                            <td>{{ device.user_id }}</td>
                            <td>{{ device.date }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div class="dashboard-table">
                <div class="dashboard-headers">
                    <div class="dashboard-switcher">
                        <p @click="users = true" :class="{active: users}">Свежие пользователи</p>
                        <p @click="users = false" :class="{active: !users}">Гости</p>
                    </div>
                    <div class="dashboard-switcher">
                        <p class="active">Найдено {{filterByClear.length}}</p>
                    </div>
                </div>
                <table v-if="users">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th style="width: 54px"></th>
                            <th>
                                <div class="dashboard-table__space" v-if="search_open">
                                    <input type="search" v-model="search">
                                    <img @click="search_open = false" src="@/assets/images/icons/icon_close.svg" width="16px">
                                </div>
                                <div class="dashboard-table__space" v-else>
                                    <p>Имя</p>
                                    <img @click="search_open = true" src="@/assets/images/icons/icon_search-b.svg" width="16px">
                                </div>
                            </th>
                            <th>
                                <p>Email</p>
                            </th>
                            <th>
                                <p>Зарегистрирован</p>
                            </th>
                            <th @click="filter = !filter">Last activity</th>
                            <th>Activated</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in filterBy" :key="user.id">
                            <td>{{ user.id }}</td>
                            <td>
                                <router-link tag="div" :to="{name: 'user', params: {id: user.id}}" class="dashboard-table__circle"
                                    :style="{backgroundImage: 'url('+user.avatar+')'}">
                                </router-link>
                            </td>
                            <td>{{ user.firstname }} {{ user.lastname }}</td>
                            <td>{{ user.email }}</td>
                            <td>{{ getDate(user.date_registration) }}</td>
                            <td>{{ getDate(user.last_activity) }}</td>
                            <td>{{ user.activated ? 'true' : 'false' }}</td>
                            <td align="center" @click="active = user">
                                <!-- <div class="button" 
                                    @click="sendActivation(user)"
                                    v-if="!user.activated">
                                    <p>{{wasSended(user) ? 'Отправлен' : 'Активация'}}</p>
                                </div> -->
                                <img src="@/assets/images/icons/list.svg" />
                            </td>
                        </tr>

                    </tbody>
                </table>
                <table v-else>
                    <thead>
                        <tr>
                            <th>IP</th>
                            <th>Регион</th>
                            <th>Время</th>
                            <th>Страница</th>
                            <th>Перешел из</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in dashboard.last_guests" :key="user.id">
                            <td>{{ user.ip }}</td>
                            <td>{{ user.city + ' (' + user.country + ')' }}</td>
                            <td>{{ getDate(user.date) }}</td>
                            <td>{{ user.page || '----' }}</td>
                            <td>{{ user.referrer || '----' }}</td>
                        </tr>

                    </tbody>
                </table>
                <div class="dashboard-pagination">
                    <div class="dashboard-pagination__item"
                        @click="page--"
                    >Prev</div>
                    <div class="dashboard-pagination__item" 
                        v-for="(item, index) in paginationElems" 
                        :key="index" 
                        @click="page = item"
                        :class="{active: page == item}"
                    >{{ item }}</div>
                    <div class="dashboard-pagination__item"
                        @click="page++"
                    >Next</div>
                </div>
            </div>
          </div>
          <Actions 
            v-if="active" 
            :options="options" 
            @action="actionsHandler"
            @close="active = null" />
      </div>
  </section>
</template>

<script>

export default {
  name: 'dashboard',
  data() {
    return {
      dashboard: null,
      updated: null,
      time: null,
      users: true,
      filter: null,
      sended: [],
      page: 1,
      search: '',
      search_open: false,
      options: [
          {
              important: false,
              action: 'send_activation',
              text: 'Письмо активации'
          },
          {
              important: true,
              action: 'delete',
              text: 'Удалить'
          }
      ],
      active: null
    };
  },
  components: {
      LineChart: () => import('@/components/Blocks/Charts/Line'),
      Actions: () => import('@/components/UI/Actions')
  },
  computed: {
    getUser () {
      return this.$store.getters.getAuthUser
    },
    getCTR() {
        return (this.dashboard.counters.register_today / (this.getGuests() / 100)).toFixed(2)
    },
    getChartData() {
        return [
            {
                label: 'Зарегистрировано',
                data: this.dashboard.charts.register_month,
                borderColor: "#2fe388",
                backgroundColor: 'transparent',
            },
            {
                label: 'Гости',
                data: this.dashboard.charts.guest_month,
                borderColor: "#2fc1e3",
                backgroundColor: 'transparent',
            },
            {
                label: 'CTR',
                data: this.dashboard.charts.ctr,
                borderColor: "#ff5a3f",
                backgroundColor: 'transparent',
            },
        ]
    },
    paginationElems() {
        return 10
        // return this.users 
        //     ? this.filterByClear
        //         ? this.filterByClear.length / 10
        //         : 0
        //     : 0
    },
    filterBy () {
        return this.filterByClear.slice(this.page * 20 - 20, this.page * 20)
    },
    filterByClear () {
        let users = this.dashboard.last_ten;
        this.filter 
            ? users.sort((a,b) => new Date(b.last_activity) - new Date(a.last_activity)) 
            : users.sort((a,b) => new Date(b.date_registration) - new Date(a.date_registration));
        if (this.search.length > 0 && this.search_open) {
            users = users.filter(user => user.search_field.indexOf(this.search) !== -1 )
        }
        return users
    },
    
  },
  methods: {
    actionsHandler(action) {
        switch (action.action) {
            case 'send_activation':
                this.sendActivation(this.active)
                break;
        
            case 'delete':
                this.deleteUser(this.active)
                break;
        }
        this.active = null
    },
    deleteUser(user) {
        this.$axios.post('/api/dashboard/user/delete', {user_id: user.id})
        .then(() => {
            let finded = this.dashboard.last_ten.find(item => item.id == user.id);
            let index = this.dashboard.last_ten.indexOf(finded);
            this.dashboard.last_ten.splice(index, 1)
            this.$store.dispatch('addNotification', {message: `Пользователь ${user.firstname} ${user.lastname} удален`})
        })
        .catch(error => {
            this.$store.dispatch('addError', {message: error})
        })
    },
    wasSended(user) {
        return this.sended.find(item => item.id === user.id)
    },
    async sendActivation(user) {
        if (this.wasSended(user)) {
            this.$store.dispatch('addNotification', {message: `Письмо уже было отправлено`})
        } else {
            await this.$axios.post(`/api/auth/newactivation`, {pepper: process.env.VUE_APP_PEPPER, email: user.email})
            .then(res => {
                if (res.data) {
                    this.sended.push(user)
                    this.$store.dispatch('addNotification', {message: `Письмо с активацией отправлено на ящик ${user.email}`})
                } else {
                    this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
                }
                
            })
            .catch(() => {
                this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
            });
        }
    },
    getGuests(start, end) {
        let guests = this.dashboard.last_guests;
        let start_day = start ? this.$moment(start) : this.$moment().add(0,'days');
        let end_day = end ? this.$moment(end) : this.$moment().add(0,'days');
        let today = guests.filter(guest => this.$moment(guest.date) >= this.$moment(start_day).startOf('day') && this.$moment(guest.date) <= this.$moment(end_day).endOf('day'));
        let result = today && today.length > 0 
            ? [...new Set(today.map(x => x.ip))].length
            : 0
        return result
    },
    sendActivations() {
        this.$axios.get('/api/dashboard/activations')
        .then(response => {
            this.$store.dispatch('addNotification', {message: `Успешно отправлено ${response.data} пользователям`})
        })
        .catch(error => {
            this.$store.dispatch('addError', {message: error})
        })
    },
    async loadData() {
      this.$axios.get('/api/dashboard/users')
      .then(response => {
        this.time = this.$moment();
        this.setUpdatedTime(this.time)
        this.dashboard = response.data
      })
    },
    setUpdatedTime(time) {
        let people_date = this.$moment(time).locale('ru').fromNow();
        let comp_date = this.$moment(time).format('HH:mm:ss');
        this.updated = people_date + ' (' + comp_date + ')';
    },
    startLoadingData() {
      return setInterval(async () => {
        this.loadData();
      }, 2 * 60 * 1000);
    },
    getDate(date) {
        return date ? this.$moment(date).locale('ru').format('HH:mm:ss | DD MMM YYYY') : '----'
    },
    loopUpdatedTime() {
        setInterval(() =>{
            this.setUpdatedTime(this.$moment(this.time))
        }, 2000)
    }
  },
  async mounted() {
    await this.loadData();
    this.startLoadingData()
    this.loopUpdatedTime()
  },
  created() {
    document.title = this.$route.meta.title;
  }
};
</script>
<style lang="stylus" scoped>
    .dashboard
        width 100%
        padding-bottom 40px

        &-headers
            display flex
            justify-content space-between
        &-pagination
            display flex
            padding 20px 0
            justify-content flex-end
            &__item
                padding 10px
                margin 5px
                background-color #f4f4f4
                border-radius 5px
                font-weight 500
                transition 0.3s all
                cursor pointer
                &:hover
                    background-color #101010
                    color white
                &.active
                    background-color #101010
                    color white
        &-update
            padding 40px 0
            font-size 14px
            font-weight 500
            text-align center

        h3
            font-weight 600
            font-size 20px

        &-switcher
            font-weight 600
            font-size 20px
            display flex
            p
                color #eaeaea
                margin-right 10px
                &.active
                    color black

        &-counters
            display flex

            .button
                display flex
                align-items center
                border-radius 20px
                border none
                background-color #f7f7f7
                padding 20px
                &:hover
                    color black
        
        &-counter
            border-radius 20px
            background-color #f7f7f7
            padding 20px
            margin-right 20px
            p
                padding-bottom 20px
                font-size 20px
            h3
                font-size 44px 
        
        &-charts
            margin 20px 0
            margin-top 40px
        &-table
            margin-top 70px

            &__space
                display flex
                justify-content space-between
            table
                width 100%
                font-size 14px
                font-weight 500
                margin-top 30px
                input
                    border none
                    background-color #eaeaea
                    padding 4px 15px
                    border-radius 8px
                th
                    padding 7px
                    text-align left
                td
                    padding 7px
                    border 2px solid white
                    background-color #f7f7f7
            
            &__circle
                width 40px
                height 40px
                border-radius 50%
                background-size cover
</style>
